<template>
  <div>
    <ManageUser />
  </div>
</template>
<script>
import ManageUser from "@/components/User/ManageUser";
export default {
  components: {
    ManageUser,
  },
  created() { this.year = JSON.parse(
        Decode.decode(localStorage.getItem("yearSelected"))
      );
  },
};
</script>